<template>
    <el-container class="stu-page" style="margin-top: 110px">
        <el-main>
            <el-card class="box-card">
                <template #header>
                    <div class="clearfix">
                        <slot v-if="$slots.header" name="header"></slot>

                        <template v-else>
                            <i v-if="icon" class="nucfont title-icon" :class="icon"></i>
                            <span class="title-txt">{{title}}</span>
                            <div class="close-btn"  @click="closeFn">
                                <span class="close-title">{{$t('c.back')}}</span><i class="nucfont inuc-close close-icon"></i>
                            </div>
                        </template>
                    </div>
                </template>

                <slot></slot>
            </el-card>
        </el-main>
    </el-container>
</template>

<script>
    export default {
        props: {
            icon: String,
            title: String,
            closeFn: {
                type: Function,
                default() {
                    return (() => {
                        history.go(-1);
                    })()
                }
            }
        },
        data() {
            return {}
        },
        computed: {},
        mounted() {
            //return;
            $('.app-main').css({
                overflowY: 'hidden'
            })
        },
        methods: {
        },
        destroyed() {
            $('.app-main').css({
                overflow: 'auto'
            });
        },
        components: {}
    }
</script>

<style lang="scss">
    @import '../style/const.scss';

    .stu-page {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: 10;
        background-color: #fff;
        @include scrollbar(#999);

        .el-main {
            //min-width: 1367px - $w-aside;
        }
        .el-card__header {
            padding: 10px 20px 0 20px;
            font-size: 22px;
            border-bottom: none;
        }
        .el-card{
            width: 75%;
            min-width: 1200px;
            margin: 0 auto;
            border: none;
            background-color: transparent;
            @media screen and (max-width: 1280px) {
                min-width: 960px;
            }
            &.is-always-shadow {
                box-shadow: none
            }
        }

        .title-icon {
            font-size: 22px;
        }

        .title-txt {

        }

        .close-btn{
            font-size: 13px;
            background-color: rgb(247, 248, 251);
            width: 63px;
            text-align: right;
            height: 28px;
            line-height: 28px;
            border-radius: 12px;
            float: right;
            cursor: pointer;
            .close-title{
                padding-right: 5px;
                color: rgb(47,128,171);
            }
            .close-icon{
                padding: 2px 3px 2.5px 3px;
                border-radius: 15px;
                color: #fff;
                background-color:rgb(47,128,171);
                font-size: 18px;
            }
            &:hover{
                box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.16), 0px 0px 15px rgba(0, 0, 0, 0.12);
            }
        }
    }
</style>
